import { AlertCircle } from 'lucide-react';

import { Alert, AlertDescription } from '@/ui/base/alert';

/**
 * A frase que a API devolveu para o passo atual — código incorreto, espere,
 * limite. Fica no fluxo da tela, e não num aviso passageiro: quem usa leitor de
 * tela ouve pela região viva, e quem demora a ler não a perde.
 */
export function AvisoDoPasso({ aviso }: { aviso: string | null }) {
  if (!aviso) return null;
  return (
    <Alert variant="destructive" role="alert">
      <AlertCircle aria-hidden="true" className="h-4 w-4" />
      <AlertDescription>{aviso}</AlertDescription>
    </Alert>
  );
}
